module.exports = "https://redage.akamaized.net/src/views/player/oressale/assets/images/wood_oak.png";